import type { SessionConfig } from '../../state/types';

import type { SessionConfigureAction } from './actions.types';

export const configure: (config: SessionConfig) => SessionConfigureAction = (config) => ({
  type: 'SESSION.CONFIGURE',
  payload: config,
});
